import { render, staticRenderFns } from "./pushDeliverStats.vue?vue&type=template&id=1ef1a3a4&"
import script from "./pushDeliverStats.vue?vue&type=script&lang=js&"
export * from "./pushDeliverStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports